<template>
    <div class="container-fluid">
        <div class="row header">
            <!-- 返回按钮, 专为 iOS/... 设计 -->
            <div v-on:click="back()" class="col-md-1 col-xs-1 back"><img src="../../assets/back.png" alt=""></div>
            <!-- logo 占位 -->
            <div class="col-md-10 col-xs-10"><img src="../../assets/netvue_logo.png" alt=""></div>
        </div>
        <!-- 显示提示语, 或者评分规则 -->
        <p>{{commentTip}}</p>
        <div class="row">
            <div class="col-xs-12 stars">
                <ul class="list-inline">
                    <!-- 评分 UI, 绑定点击事件,  -->
                    <li v-for="(star, index) in stars" v-on:click="starClicked(index)">
                        <span
                            :class="['glyphicon', { 'glyphicon-star': star.active,  'glyphicon-star-empty': !star.active }]"></span>
                    </li>
                </ul>
            </div>
        </div>
        <form @submit.prevent="submit()">
            <!-- 提交按钮 -->
            <button type="submit" class="btn btn-success">{{submitText}}</button>
        </form>
    </div>
</template>

<script>
    export default {
        name: 'activities',
        data () {
            return {
                // 评分提示语
                commentTip: '',
                // 提交按钮文案
                submitText: 'Submit',
                // 好评的标准(用户评分 > 标准 = 好评)
                goodScore: 0,
                // 用户评分
                userScore: 0,
                // 差评相关内容, 会通过 saveData 反馈给 Native, Native 注意拦截实现
                badReview: {},
                // 好评相关内容
                goodReview: {},
                stars: [
                    {
                        active: false
                    },
                    {
                        active: false
                    },
                    {
                        active: false
                    },
                    {
                        active: false
                    },
                    {
                        active: false
                    }
                ],
                form: {}
            }
        },
        mounted () {
            // 加载资源, 解析参数
            this.nvOnLoad(function (context) {
            })
            var that = this
            // 从本地读取评分规则
            this.nvGetDefaultJson('rules.json', function (response) {
                var rules = response.data
                // 找到匹配的评分规则, 由活动类型决定
                var rule = rules[that.activityType]
                // 赋值好评/差评内容
                that.goodReview = rule['goodReview']
                that.badReview = rule['badReview']
                // 根据规则填充页面内容
                if (rule !== undefined && rule !== '') {
                    document.title = rule.title
                    that.commentTip = rule.comment
                    that.submitText = rule.submit
                    that.goodScore = rule.score
                }
            })
        },
        methods: {
            starClicked (idx) {
                console.log('## star ' + idx + ' clicked')
                this.userScore = idx + 1
                var i = 0
                for (; i <= idx; i++) {
                    this.stars[i].active = true
                }
                for (; i < 5; i++) {
                    this.stars[i].active = false
                }
            },
            openRouter (routerMethod, routerURL, routerCfg) {
                // console.log('routerCfg: ' + JSON.stringify(routerCfg))
                var resultReview = routerCfg.resultReview
                if (resultReview.redirect !== undefined && resultReview.redirect !== '') {
                    // 如果存在页面重定向, 则跳转到重定向页面
                    location.href = resultReview.redirect
                } else {
                    // 如果是 Android/iOS, 路由到特定页面
                    delete routerCfg.resultReview
                    console.log('routerCfg: ' + JSON.stringify(routerCfg))
                    if (window.nvJsAPI !== undefined) {
                        window.nvJsAPI.ui.openRouter(routerURL, routerMethod, routerCfg)
                    } else {
                        console.log('## nvJsAPI not found')
                    }
                }
            },
            submit () {
                var routerURL = '/menu/activities/comment'
                var routerMethod = 'submit'
                var routerCfg = {
                    userScore: this.userScore,
                    goodScore: this.goodScore,
                    activityId: this.activityId,
                    activityType: this.activityType,
                    resultReview: this.userScore > this.goodScore ? this.goodReview : this.badReview
                }
                // 提交前, 将表单内容(路由配置)交由 Native 层保存, 以便在需要重定向的页面中读取, 供 nvjsinject-*.js 用
                if (window.nvJsAPI !== undefined) {
                    window.nvJsAPI.sys.saveData('commentForm', routerCfg, 0)
                }
                this.openRouter(routerMethod, routerURL, routerCfg)
            },
            back () {
                this.$router.go(-1)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @media only screen and (max-width: 768px) {
        .header {
            height: 110px;
            padding-top: 40px;
            padding-bottom: 30px;
        }

        .header div[class*="col-"] {
            height: 30px;
        }

        .stars {
            padding-bottom: 20px;
        }

        .header .back {
            padding-top: 5px;
            padding-left: 10px;
        }
    }

    @media (min-width: 768px) {
        .header {
            height: 192px;
            padding-top: 64px;
            padding-bottom: 42px;
        }

        .header div[class*="col-"] {
            height: 70px;
        }

        .stars {
            padding-bottom: 50px;
        }

        .header .back {
            padding-top: 10px;
            padding-left: 15px;
        }
    }

    @media (min-width: 992px) {
        .header {
            height: 220px;
            padding-top: 82px;
            padding-bottom: 67px;
        }

        .header div[class*="col-"] {
            height: 80px;
        }

        .stars {
            padding-bottom: 60px;
        }

        .header .back {
            padding-top: 12px;
            padding-left: 18px;
        }
    }

    @media (min-width: 1200px) {
        .header {
            height: 280px;
            padding-top: 100px;
            padding-bottom: 80px;
        }

        .header div[class*="col-"] {
            height: 100px;
        }

        .stars {
            padding-bottom: 70px;
        }

        .header .back {
            padding-top: 15px;
            padding-left: 25px;
        }
    }

    .header div[class*="col-"] {
        text-align: center;
    }

    .header img {
        height: 100%;
        width: auto;
    }

    form button {
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// Comment.vue?23287b92